export default __webpack_public_path__ + "static/media/127.680be37b.jpg";